import Card from 'scripts/models/api/cards/base/card';
import can from 'can'

export default Card.extend({
    define: {
        video: {
            Type: can.Map,
            Value: null
        },
        title: {
            type: 'string',
            value: ''
        },
        shareUrl: {
            type: 'string',
            value: ''
        },
        isFeatured: {
            type: 'boolean',
            value: false
        }
    }
});
